
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";
import Modal from "../components/model";


const Login = () => {

    // State for Login ID text Box 
    const [userID, setUserID] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();


    const handleLogin = async (event) => {

        event.preventDefault();

        const validatedata = {
            userID: userID,
            password: password
        };

        // Validate input before triggering the API call
        if (!userID || !password) {
            setErrorMessage("Please enter both user ID and password.");
            return;
        }
        const response = await fetch('https://igapi.heuristticminds.com/api/UsersList/Login-ValidateUser', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(validatedata), // Replace with your data
        });
        // Clear previous error message
        setErrorMessage("");

        if (response.ok) {

            const data = await response.json();

            localStorage.setItem('admin-info', JSON.stringify(data));

            setErrorMessage("Valid User");
            if (data.userType_id === 1) {
                navigate(`/dashboard`);
            }
            else if (data.userType_id === 2) {
                navigate(`/landingArtist`);
            }
            else if (data.userType_id === 3) {
                navigate(`/`);
            }
            else if (data.userType_id === 4) {
                navigate(`/landingReSeller`);
            }

        } else {
            setErrorMessage("InValid User");
        }

    };


    return (
        <>
            <Header />
            <div className="bg-light p-4" style={{ marginTop: '110px' }}>
                <div className="col-sm-8 m-auto">
                    <div className="row no-gutters shadow-lg">
                        <div className="col-md-5 d-none d-md-block p-0">
                            <img src="images/login-bg.jpg" className="img-fluid h-100" alt="Login Background" />
                        </div>
                        <div className="col-md-7 bg-white p-5">
                            <h4 className="pb-3 text-center">Login your Account</h4>
                            <div className="form_style">
                                <form>
                                   
                                    <div className="row_input">
                                        <span className="lbl1">Email/Mobile</span>
                                        <input
                                            type="text"
                                            value={userID}
                                            placeholder="Enter Email/Mobile"
                                            className="txt1"
                                            id="exampleInputEmail1" aria-describedby="emailHelp"
                                            onChange={(e) => setUserID(e.target.value)}
                                            autoComplete="off"
                                        />
                                    </div>
                                    <div className="row_input">
                                        <span className="lbl1">Password</span>
                                        <input
                                            type="password"
                                            value={password}
                                            placeholder="Password"
                                            className="txt1"
                                            id="exampleInputPassword1"
                                            onChange={(e) => setPassword(e.target.value)}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    handleLogin(e);
                                                }
                                            }
                                            }

                                        />
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between mb-1">
                                        <div className="d-flex align-items-center"><input id="check1" name="" type="checkbox" value="" />&nbsp;<label for="check1" className="pl-2 font-weight-bold">Remember Me</label></div>
                                        <small><Link to="/forgetPassword">Forget Password?</Link></small>
                                    </div>
                                    <div className="pb-2">
                                        <button
                                            type="submit"
                                            className="btn btn-dark w-100 font-weight-bold mt-2 p-2 rounded-1"
                                            onClick={handleLogin}>
                                            Login
                                        </button>
                                    </div>
                                    {errorMessage && <div className="text-danger">{errorMessage}</div>}
                                </form>
                                <div className="pt-2 text-center">
                                    <Link className="btn btn-light" to={'/signup'}>Sign Up</Link>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
          
            <Footer />

        </>
    )
}


export default Login;